module.exports = require('./lib/axios');


// WEBPACK FOOTER //
// /Users/reyno/Sites/battlehouse/wp-content/themes/battlehouse/node_modules/axios/index.js